import React from "react"
import { Card, CardLoading } from "."
import SectionHeading from "../SectionHeading"
import PropTypes from "prop-types"

const CardList = ({
  items,
  primaryField,
  secondaryFields,
  footerField,
  heading,
  headingChildren,
  onCardClick,
  emptyListImageUrl,
  emptyListMessage,
  isLoading,
  isDeletable,
  onDeleteClick,
  isSelectable,
  onSelectChange,
  selectableField
}) => {
  return (
    <div className="d-f fd-c g-1 mb-1">
      {heading && (
        <div className="card-header">
          <SectionHeading {...heading}>{headingChildren}</SectionHeading>
        </div>
      )}
      {isLoading && <CardLoading />}
      {!isLoading &&
        items.length > 0 &&
        items.map(item => (
          <Card
            key={item.key || item.id}
            item={item}
            primaryField={primaryField}
            secondaryFields={secondaryFields}
            footerField={footerField}
            onCardClick={onCardClick}
            isDeletable={isDeletable}
            onDeleteClick={onDeleteClick}
            isSelectable={isSelectable}
            onSelectChange={onSelectChange}
            selectableField={selectableField}
          />
        ))}
      {!isLoading && items.length === 0 && (
        <div className="ta-c p-4">
          <div className="blank-state__hero">
            {emptyListImageUrl && <img src={emptyListImageUrl} className="mb-4" alt="No results" />}
          </div>
          <div className="blank-state__msg">{emptyListMessage || "No results"}</div>
        </div>
      )}
    </div>
  )
}

CardList.propTypes = {
  items: PropTypes.array,
  primaryField: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.node]),
  secondaryFields: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.node])
  ),
  footerField: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.node]),
  heading: PropTypes.shape({
    headerText: PropTypes.node,
    headerSubText: PropTypes.node,
    headerActions: PropTypes.arrayOf(
      PropTypes.shape({
        onClick: PropTypes.func,
        linkTo: PropTypes.string,
        text: PropTypes.string
      })
    ),
    className: PropTypes.string,
    style: PropTypes.shape({})
  }),
  headingChildren: PropTypes.node,
  onCardClick: PropTypes.func,
  emptyListMessage: PropTypes.string,
  emptyListImageUrl: PropTypes.string,
  isLoading: PropTypes.bool,
  isDeletable: PropTypes.bool,
  onDeleteClick: PropTypes.func,
  isSelectable: PropTypes.bool,
  onSelectChange: PropTypes.func,
  selectableField: PropTypes.string
}

export default CardList
